// React
import React, { useContext } from 'react';

// Material UI
import { Grid, Button, Dialog, DialogContent, DialogTitle, DialogActions, Typography } from '@material-ui/core';

// Styles
import styles from './ExportFiltersModal.module.scss';

// Third party
import { trackPromise } from 'react-promise-tracker';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Services
import { exportFiltersModalData } from '../../../services/data-types';

export default function ExportFiltersModal({
  isOpen,
  onExportFiltersModalClose
}) {

  // Get info about modal filters from the listing context.
  const {
    endpointFiltersModalExport,
    getExportFilters,
    activeExportFilters,
  } = useContext(ListingContext);

  const filters = getExportFilters();

  const handleExport = (event) => {
    event.preventDefault();

    const promise = exportFiltersModalData({
      endpoint: endpointFiltersModalExport,
      activeExportFilters
    });

    trackPromise(
      promise.then((response) => {
      })
    );
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onExportFiltersModalClose}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h2" component="div">
          Export Data
        </Typography>
      </DialogTitle>
      <DialogContent className={styles['modal-content']}>
        {filters &&
          filters.map((row, i) => {
            return (
              <div key={i}>
                <Grid container spacing={3}>
                  {row &&
                    row.map((filter, j) => {
                      return (
                        <Grid
                          key={j}
                          item
                          xs={filter.size.xs}
                          md={filter.size.md}
                          lg={filter.size.lg}>
                          {filter.component}
                        </Grid>
                      );
                    })}
                </Grid>
              </div>
            );
          })}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onExportFiltersModalClose}
          disableElevation={true}
          color="secondary"
          variant="outlined"
          size="large">
          cancel
        </Button>
        <Button
          onClick={handleExport}
          disableElevation={true}
          color="secondary"
          variant="contained"
          size="large">
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}